import Ajax from '@/lib/ajax'
import getUrlConfig from '@/lib/urlConfig'

const uploadApi = getUrlConfig.uploadApi
const downloadApi = getUrlConfig.downloadApi
const api = getUrlConfig.api

const downloadApiMG = getUrlConfig.downloadApiMG
const magApiPDF = getUrlConfig.magApiPDF

const checkApi = getUrlConfig.checkApi
const checkApiSEA = getUrlConfig.checkApiSEA

/**
 * 上传 文件
 * @param {object} data
 */
export const uploadFileService = (data) =>
    Ajax.uploadFile(uploadApi + '/uploadFileService', data);
/**
 * 下载 文件--企业端
 * @param {object} data
 */
export const fileDownloadService = (data) =>
    Ajax.downloadFile(downloadApi + '/fileDownloadService', data);
/**
 * 公开端-预览 2019年及之前 pdf文件
 * @param {object} data
 */
export const viewPdfAPi = (data) =>
    Ajax.viewPdfFIle(api + '/fileDownloadService', data);
/**
 * 公开端-预览 2020年及之后 pdf文件
 * @param {object} data
 */
export const viewPdfAPi2020 = (data) =>
    Ajax.viewPdfFIle(api + '/downloadInfoPublishFileService', data);
/**
 * 公开端-下载 2020年及之后 pdf文件
 * @param {object} data
 */
export const downloadPdfAPi2020 = (data) =>
    Ajax.downloadFile(downloadApi + '/downloadInfoPublishFileService', data);
/**
 * 下载 数据表--企业端
 * @param {object} data
 */
export const downLoadReportExcelService = (data) =>
    Ajax.downloadFile(downloadApi + '/downLoadReportExcelService', data);
/**
 * 下载 排放报告-企业端
 * @param {object} data
 */
export const downloadFileService = (data) =>
    Ajax.downloadFile(downloadApi + '/downloadFileService', data);
/**
 * 上传 不符合项清单文件--企业端
 * @param {object} data
 */
export const notConformUploadFile = (data) =>
    Ajax.uploadFile(uploadApi + '/notConformUploadFile', data);
/**
 * 下载 质量控制计划表-企业端
 * @param {object} data
 */
export const exportPlanFileService = (data) =>
    Ajax.downloadFile(downloadApi + '/exportPlanFileService', data)


/**
 * 批量下载 附件材料
 * @param {object} data
 */
export const downloadFileBatch = (data) =>
    Ajax.downloadFile(downloadApi + '/downloadFileBatch', data)

/**
 * 下载 文件--管理端
 * @param {object} data
 */
export const downloadAttachments = (data) =>
    Ajax.downloadFile(downloadApiMG + '/downloadAttachments', data);
    
/**
 * 公开端 附件查看pdf
 * @param {object} data
 */
export const viewPdfAttachments = (data) =>
    Ajax.viewPdfFIle(checkApiSEA + '/downloadAttachments', data, "SEA");

/* 公开端-查看 核查端信息公开 - pdf
 * @param {object} data
 */
export const viewPdfAPiService = (data) =>
    Ajax.viewPdfFIle(checkApi + '/downloadPublishInfoPdfFileService', data);

/**
 *燃料信息表导出
 * @param {object} data
 */
 export const exportFuelAnalysis = (data) =>
 Ajax.downloadFileAndLoading(api + '/exportFuelAnalysis', data)

/**
*燃料信息表导入
* @param {object} data
*/
export const importFuelAnalysis = (data) =>
    Ajax.uploadFile(uploadApi + '/importFuelAnalysis', data);

/**
 *购入使用电量表导出
 * @param {object} data
 */
 export const exportMeterUse = (data) =>
 Ajax.downloadFileAndLoading(api + '/exportMeterUse', data)

/**
*购入使用电量表导入
* @param {object} data
*/
export const importMeterUse = (data) =>
    Ajax.uploadFile(uploadApi + '/importMeterUse', data);

/**
 *生产数据表导出
 * @param {object} data
 */
 export const exportProductCapacity = (data) =>
 Ajax.downloadFileAndLoading(api + '/exportProductCapacity', data)

/**
*生产数据表导入
* @param {object} data
*/
export const importProductCapacity = (data) =>
    Ajax.uploadFile(uploadApi + '/importProductCapacity', data);

/**
 *确认方式表导出
 * @param {object} data
 */
 export const exportDetermineWay = (data) =>
 Ajax.downloadFileAndLoading(api + '/exportDetermineWay', data)

/**
*确认方式表导入
* @param {object} data
*/
export const importDetermineWay = (data) =>
    Ajax.uploadFile(uploadApi + '/importDetermineWay', data);

/**
 *生产设施表导出
 * @param {object} data
 */
 export const exportProductionFacilities = (data) =>
 Ajax.downloadFileAndLoading(api + '/exportProductionFacilities', data)

 /**
 *信息汇总导出
 * @param {object} data
 */
 export const exportTotalInfo = (data) =>
 Ajax.downloadFileAndLoading(api + '/exportTotalInfo', data)